const hideHeaderPaths = [
  { path: '/cars/', exact: true },
  { path: '/quote/', exact: false },
  { path: '/cars/deal-confirmation/', exact: false },
  { path: '/booking-confirmation/', exact: false },
  { path: '/car-drop/', exact: false },
  { path: '/campaign-cars/', exact: false },
  { path: '/remind-you-later/', exact: false },
  { path: '/wishlist', exact: false },
  { path: '/compare-variants/', exact: false },
  { path: '/acko-app/', exact: false },
  { path: '/help-me-buy/', exact: false },
  { path: '/callback-confirmation', exact: false },
  { path: '/see-how-ratings-work', exact: false },
  { path: '/upsell', exact: false },
  { path: '/v2/car-valuation/', exact: false },
];

const hideHeaderWhenInAppPaths = [
  { path: '/compare', exact: false },
  { path: '/terms-and-conditions', exact: false },
  { path: '/car-valuation/', exact: false },
];

export const hideCityAndSearchMobile = [
  { path: '/used/', exact: false },
  { path: '/car-valuation/', exact: false },
];

const mobileBackHeaderPaths = [
  '/my-booking',
  '/v2/kyc',
  '/v2/loan-documents',
];

export const shouldUseMobileBackHeader = (pathname: string): boolean =>
  mobileBackHeaderPaths.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`)
  );

export const shouldHideHeader = (pathname: string, isInApp?: boolean): boolean => {
  const hideByPath = hideHeaderPaths.some(({ path, exact }) => {
    if (exact) {
      return pathname === path || pathname === `${path}`;
    }
    return pathname === path || pathname?.includes(`${path}`);
  });
  if (hideByPath) return true;

  if (isInApp) {
    const hideByInAppPath = hideHeaderWhenInAppPaths.some(({ path, exact }) => {
      if (exact) {
        return pathname === path || pathname === `${path}`;
      }
      return pathname === path || pathname?.includes(`${path}`);
    });
    if (hideByInAppPath) return true;
  }

  return false;
};
